export default '/build/bfec42f3.svg'